import { createSlice } from "@reduxjs/toolkit";

const saved = JSON.parse(localStorage.getItem("cart")) || { items: [] };
const initialState = { items: saved.items };

const slice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, { payload }) => {
      // payload: { id, name, price, image, qty? }
      const qty = payload.qty ?? 1;
      const idx = state.items.findIndex((i) => i.id === payload.id);
      if (idx > -1) state.items[idx].qty += qty;
      else state.items.push({ ...payload, qty });
    },
    console: {
      log: (message) => {
        console.log(message);
      },
    },
    increaseQty: (state, { payload }) => {
      const item = state.items.find((i) => i.id === payload);
      if (item) item.qty += 1;
    },
    decreaseQty: (state, { payload }) => {
      const item = state.items.find((i) => i.id === payload);
      if (item) item.qty = Math.max(0, item.qty - 1);
    },
    removeItem: (state, { payload }) => {
      state.items = state.items.filter((i) => i.id !== payload);
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, increaseQty, decreaseQty, removeItem, clearCart } =
  slice.actions;

// Selectors
export const selectCartItems = (s) => s.cart.items;
export const selectCartCount = (s) =>
  s.cart.items.reduce((n, i) => n + i.qty, 0);
export const selectCartTotal = (s) =>
  s.cart.items.reduce((n, i) => n + i.qty * (Number(i.price) || 0), 0);

export default slice.reducer;
